<template>
    <div>
        <div style='background: rgba(28,127,118,0.16);border: 1px solid;height: 840px;border-image: linear-gradient(165deg, rgba(44, 139, 131, 0), rgba(77, 241, 227, 1)) 1 1;'>

        </div>
    </div>
</template>
<script>
    export default {
        props: [],
        data() {
            return {}
        },
        created() {},
        methods: {}
    }
</script>
<style scoped>
</style>